/* import __COLOCATED_TEMPLATE__ from './mini-splash.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();